var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPiscada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 102,
    viewBox: "0 0 101 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3826_30393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.4894 73.1101C87.8047 59.7948 87.8047 38.2064 74.4894 24.8911C61.1741 11.5758 39.5857 11.5758 26.2704 24.8911C12.9551 38.2064 12.9551 59.7948 26.2704 73.1101C39.5857 86.4254 61.1741 86.4254 74.4894 73.1101Z",
    fill: "#FFD05D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.22 19.9C72.375 26.4024 74.2018 34.1219 73.4018 41.7969C72.6018 49.4719 69.2222 56.6486 63.8154 62.1543C58.4087 67.66 51.2944 71.1691 43.6351 72.1081C35.9759 73.0471 28.2246 71.3605 21.6479 67.324C24.4087 71.6443 28.108 75.2865 32.4708 77.9796C36.8337 80.6726 41.7476 82.3472 46.847 82.8788C51.9464 83.4103 57.1001 82.7852 61.9245 81.0498C66.7489 79.3144 71.1199 76.5134 74.7123 72.8553C78.3046 69.1973 81.0259 64.7762 82.6735 59.9211C84.3212 55.066 84.8528 49.9019 84.2289 44.813C83.605 39.724 81.8416 34.8413 79.0699 30.528C76.2982 26.2147 72.5896 22.582 68.22 19.9Z",
    fill: "#FDC453"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9199 52.6C20.92 45.9888 22.9898 39.5436 26.8392 34.1686C30.6885 28.7936 36.124 24.7587 42.3831 22.63C48.6422 20.5013 55.4107 20.3856 61.7388 22.2992C68.067 24.2128 73.6372 28.0597 77.6679 33.3C75.5056 29.5448 72.5953 26.2735 69.1173 23.6888C65.6393 21.104 61.6677 19.2609 57.4484 18.2735C53.2291 17.2861 48.852 17.1754 44.5882 17.9484C40.3244 18.7213 36.2647 20.3615 32.6606 22.7672C29.0564 25.1729 25.9846 28.2929 23.6352 31.9341C21.2859 35.5752 19.7091 39.6599 19.0026 43.9352C18.2961 48.2105 18.4748 52.5853 19.5277 56.7887C20.5807 60.9922 22.4854 64.9346 25.1239 68.372C22.3629 63.5746 20.913 58.1351 20.9199 52.6Z",
    fill: "#FFD77F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.272 53.3401C63.628 53.2961 63.832 53.7401 63.828 54.0681C63.7885 55.6735 63.3778 57.2479 62.628 58.6681C61.8576 60.118 60.8161 61.4067 59.56 62.4641C56.9672 64.5982 53.7181 65.7735 50.36 65.7921C46.9813 65.8505 43.6973 64.6743 41.124 62.4841C38.536 60.2721 36.96 57.1281 36.912 54.0841C36.912 53.7361 37.14 53.2841 37.528 53.3561C37.848 53.4161 38.112 53.8481 38.348 54.0441C38.708 54.3481 39.088 54.6361 39.472 54.9081C40.241 55.4488 41.0425 55.9417 41.872 56.3841C44.9453 58.0826 48.4456 58.8524 51.948 58.6001C54.1686 58.3879 56.3277 57.751 58.308 56.7241C59.4951 56.1102 60.625 55.3913 61.684 54.5761C62.084 54.2681 62.744 53.4401 63.24 53.3481L63.272 53.3401Z",
    fill: "#5E4939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.932 42.9001C39.932 45.2361 38.808 47.1321 37.42 47.1321C36.032 47.1321 34.908 45.2361 34.908 42.9001C34.908 40.5641 36.032 38.6641 37.42 38.6641C38.808 38.6641 39.932 40.5601 39.932 42.9001Z",
    fill: "#303030"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.932 44.3041C67.467 43.1422 66.6674 42.1447 65.6345 41.438C64.6017 40.7314 63.3822 40.3475 62.1308 40.335C60.8794 40.3226 59.6525 40.6822 58.6059 41.3682C57.5592 42.0542 56.7399 43.0357 56.252 44.1881C56.1627 44.4033 56.1503 44.6427 56.2166 44.8661C56.2829 45.0895 56.424 45.2833 56.6162 45.4151C56.8084 45.5468 57.0401 45.6085 57.2723 45.5897C57.5046 45.571 57.7234 45.4729 57.892 45.3121C59.784 43.4761 62.776 42.0041 66.292 45.4121C66.4815 45.5966 66.7355 45.6999 67 45.7001C67.2021 45.6998 67.3997 45.64 67.568 45.5281C67.7606 45.3974 67.9022 45.2042 67.9685 44.9811C68.0349 44.7579 68.0219 44.5187 67.932 44.3041Z",
    fill: "#303030"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.668 17.692C75.16 29.864 65.62 32.728 65.62 32.728C65.62 32.728 75.16 35.596 77.668 47.768C80.172 35.596 89.716 32.728 89.716 32.728C89.716 32.728 80.172 29.864 77.668 17.692Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.668 17.692C75.16 29.864 65.62 32.728 65.62 32.728C65.62 32.728 78.424 34.6 77.668 17.692Z",
    fill: "#F1F2F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3826_30393",
    x: 0.283936,
    y: 0.904663,
    width: 100.192,
    height: 100.192,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3826_30393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3826_30393",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiscada);
export default __webpack_public_path__ + "static/media/Piscada.6431bb812e5fee73019f96ba3f64e37e.svg";
export { ForwardRef as ReactComponent };